<template>
  <a-modal
    :title="$store.state.wholesale.editingInfo.isDup ? '도매 복제' : '도매 등록'"
    v-model="$store.state.wholesale.editingInfo.enabled"
    okText="등록"
    cancelText="취소"
  >
    <a-input placeholder="도매 이름" v-model="name" style="width: 100%;">
      <a-icon slot="prefix" type="tag" />
    </a-input>
    <span v-if="!!details.name" class="cl-red" style="width: 100%">{{details.name}}</span>
    <a-row style="margin-top: 0.75em">
      <a-col :span="11">
        <a-input placeholder="전화번호" @change="getMask('phone')" v-model="phone" style="width: 100%">
          <a-icon slot="prefix" type="customer-service" />
        </a-input>
        <span v-if="!!details.phone" class="cl-red" style="width: 100%">{{details.phone}}</span>
      </a-col>
      <a-col :span="1" />
      <a-col :span="12">
        <a-input
          placeholder="휴대폰 번호"
          @change="getMask('mobile')"
          v-model="mobile"
          style="width: 100%"
        >
          <a-icon slot="prefix" type="phone" />
        </a-input>
        <span v-if="!!details.mobile" class="cl-red" style="width: 100%">{{details.mobile}}</span>
      </a-col>
    </a-row>
    <a-row style="margin-top: 0.75em">
      <a-col :span="6">
        <a-select v-model="location.building" style="width: 100%" @change="onSecondary(false)">
          <a-select-option :key="name" v-for="name in first" :value="name">{{ name }}</a-select-option>
        </a-select>
        <span
          v-if="!!details.location.building"
          class="cl-red"
          style="width: 100%"
        >{{details.location.building}}</span>
      </a-col>
      <a-col :span="1" />
      <a-col :span="17">
        <a-select v-model="location.mall" style="width: 100%">
          <a-select-option :key="name" v-for="name in secondary" :value="name">{{ name }}</a-select-option>
        </a-select>
        <span
          v-if="!!details.location.mall"
          class="cl-red"
          style="width: 100%"
        >{{details.location.mall}}</span>
      </a-col>
    </a-row>
    <a-row style="margin-top: 0.75em">
      <a-col :span="7">
        <a-select v-model="location.floor" style="width: 100%">
          <a-select-option :value="floor" v-for="floor in floors" :key="floor">{{ floor }}층</a-select-option>
        </a-select>
        <span
          v-if="!!details.location.floor"
          class="cl-red"
          style="width: 100%"
        >{{details.location.floor}}</span>
      </a-col>
      <a-col :span="1" />
      <a-col :span="8">
        <a-select v-model="location.row" style="width: 100%">
          <a-select-option :value="row" v-for="row in rows" :key="row">{{ row }}열</a-select-option>
        </a-select>
        <span
          v-if="!!details.location.row"
          class="cl-red"
          style="width: 100%"
        >{{details.location.row}}</span>
      </a-col>
      <a-col :span="1" />
      <a-col :span="7">
        <a-input v-model="location.place" placeholder="호수 ('호' 없이)" style="width: 100%" />
        <span
          v-if="!!details.location.place"
          class="cl-red"
          style="width: 100%"
        >{{details.location.place}}</span>
      </a-col>
    </a-row>
    <template slot="footer">
      <a-button
        type="primary"
        :icon="$store.state.wholesale.editingInfo.isDup ?
        'copy' : ($store.state.wholesale.editingInfo.idx === '' ?
        'plus' : 'edit')"
        @click="onAdd"
      >
        {{$store.state.wholesale.editingInfo.isDup ?
        '복제' : ($store.state.wholesale.editingInfo.idx === '' ?
        '추가' : '수정') }}
      </a-button>
    </template>
  </a-modal>
</template>
<script>
import { mapActions } from "vuex";
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";

export default {
  name: "WholesaleEdit",
  data() {
    this.onLoad();
    return {
      name: "",
      phone: "",
      mobile: "",
      location: {
        building: "",
        mall: "",
        floor: "",
        row: "",
        place: ""
      },
      rows: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "특",
        "신관",
        "구관"
      ],
      first: [],
      secondary: [],
      details: { location: {} }
    };
  },
  methods: {
    ...mapActions(["refreshWholesales", "editWholesale"]),
    async onLoad() {
      try {
        this.first = [];
        this.secondary = [];
        const { data } = await Axios.get(
          `${config.hostname}/v1/wholesale/location`,
          {
            withCredentials: true
          }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.first = data.location;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류가 발생했습니다."
              });
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "오류가 발생했습니다."
        });
      }
    },
    async onSecondary(isLoad = false) {
      try {
        const { data } = await Axios.get(
          `${config.hostname}/v1/wholesale/location/details?first=${this.location.building}`,
          {
            withCredentials: true
          }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.secondary = data.location;
              if (!isLoad) this.location.mall = null;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류가 발생했습니다."
              });
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "오류가 발생했습니다."
        });
      }
    },
    async onAdd() {
      let { idx, isDup } = this.$store.state.wholesale.editingInfo;
      const { data } = await Axios.post(
        `${config.hostname}/v1/wholesale/edit/${!isDup ? idx : ""}`,
        {
          name: this.name,
          phone: this.phone,
          mobile: this.mobile,
          location: {
            building: this.location.building,
            mall: this.location.mall,
            floor: this.location.floor,
            row: this.location.row,
            place: this.location.place
          }
        },
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            if (isDup)
              await Axios.delete(`${config.hostname}/v1/wholesale/${idx}`, {
                withCredentials: true
              });

            this.refreshWholesales();
            this.editWholesale({ enabled: false });
            break;
          case OPCODE.INVALID:
            this.details = Object.assign({ location: {} }, data.details);

            config.alert.mixin({
              type: "warning",
              title: "오류를 확인해주세요."
            });
        }
      }
    },
    async getFromWholesale() {
      const { idx } = this.$store.state.wholesale.editingInfo;
      const { data } = await Axios.get(
        `${config.hostname}/v1/wholesale/${idx}`,
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.name = data.wholesale.name;
            this.phone = data.wholesale.phone;
            this.mobile = data.wholesale.mobile;
            this.location = {
              building: data.wholesale.location.building,
              mall: data.wholesale.location.mall,
              floor: data.wholesale.location.floor,
              row: data.wholesale.location.row,
              place: data.wholesale.location.place
            };

            this.onSecondary(true);
            break;
        }
      }
    },
    getMask(type) {
      let num = this[type].replace(/[^0-9]/g, "");

      let res = "";
      if (num.length < 3) {
        res = num;
      } else {
        if (num.substr(0, 2) == "02") {
          if (num.length <= 5) {
            //02-123-5678
            res = num.substr(0, 2) + "-" + num.substr(2, 3);
          } else if (num.length > 5 && num.length <= 9) {
            //02-123-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 3) + "-" + num.substr(5);
          } else if (num.length > 9) {
            //02-1234-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 4) + "-" + num.substr(6);
          }
        } else {
          if (num.length < 8) {
            res = num;
          } else if (num.length == 8) {
            res = num.substr(0, 4) + "-" + num.substr(4);
          } else if (num.length == 9) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length == 10) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length > 10) {
            //010-1234-5678
            res =
              num.substr(0, 3) + "-" + num.substr(3, 4) + "-" + num.substr(7);
          }
        }
      }

      this[type] = res;
    }
  },
  mounted() {
    if (this.$store.state.wholesale.editingInfo.idx) {
      this.getFromWholesale();
    }
  }
};
</script>